<template>
  <div>
    <v-container
      fluid
      class="pa-0 info-drawer"
    >
      <div class="pa-6">
        <h2 class="d-flex justify-space-between align center mb-1">
          Edit Campaign Tags
          <v-btn
            v-track="'close-edit-tags'"
            icon
            @click.stop="$store.commit('ui/drawer.right.toggle')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h2>
        <v-row>
          <v-col
            cols="12"
            class="body-2 pt-0 grey--text text--darken-2 font-weight-medium mb-3 text-left"
          >
            Select the tags you want to associate with the campaign.
          </v-col>
        </v-row>
        <v-btn
          v-track="'save-tags'"
          dark
          link
          :loading="loading"
          @click.stop="saveSelectedTags"
        >
          SAVE
        </v-btn>
      </div>
          <v-divider />
          <v-text-field
            v-model="searchString"
            outlined
            class="pa-6 pb-0 text--grey"
            label="Search"
            prepend-inner-icon="search"
          />
          <div class="pa-6 pt-0 list-frame">
            <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                <span class="white">  Selected Tags ({{selectedTags.length}})</span>
              </div>
              <v-list-item-group
                multiple
              >
                <v-list-item
                  v-for="list in selectedTags"
                  :key="list.id"
                  :ripple="false"
                  class="pa-0"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action class="mr-2">
                      <v-icon
                        color="#03B6FC"
                        @click="update_list(list, false)"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ list.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-list
              subheader
              two-line
              flat
            >
              <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5">
                <span class="white">  Unselected Tags ({{totalListCount - selectedTags.length > 0 ? totalListCount - selectedTags.length : 0}})</span>
              </div>
              <v-list-item-group multiple>
                <v-list-item
                  v-for="list in allLists"
                  :key="list.id"
                  class="pa-0"
                  :ripple="false"
                >
                  <template>
                    <v-list-item-action
                      class="mr-2"
                    >
                      <v-icon
                        color="grey"
                        @click="update_list(list, true)"
                      >
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ list.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item
                  v-if="showMore"
                  :ripple="false"
                  class="d-flex justify-center"
                >
                  <v-btn
                    v-track="'show-more-tags'"
                    outlined
                    @click="getAllTags()"
                  >
                    Show more
                  </v-btn>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
    </v-container>
  </div>
</template>
  <script>
  import commonFunctions from '@/commonFunctions'
  import { $reports, $cTags, $campaigns } from '@/services'

  export default {
    data () {
      return {
        allSelected: false,
        currentPage: 0,
        loading: false,
        totalListCount: 0,
        totalListCountStatic: 0,
        searchString: '',
        tagList: [],
        allLists: [],
        showMore: false
      }
    },
    watch: {
      searchString: commonFunctions._debounce(function () {
        this.currentPage = 0
        this.allLists = []
        this.getAllTags()
      }, 700),
    },
    computed: {
      selectedTags () {
        return this.tagList.filter(preset => {
          const regex = new RegExp('(' + this.searchString + ')', 'i')
          return preset.name.match(regex)
        })
      },
    },
    mounted () {
      this.currentCampaignId = this.$route.params.campaignId;
      this.tagList = this.$store.getters["ui/drawer"].right.response;
      this.getAllTags()
    },
    methods: {
      getAllTags () {
        this.loading = true
        const perPage = 10
        $cTags.fetch({
          params: {
            page: ++this.currentPage,
            per_page: perPage,
            name: this.searchString,
            show_all_tags: true
          },
        }).then(response => {
          if (response.data.data.length === perPage) this.showMore =true
          else this.showMore = false
          this.totalListCount = response.data.meta.total_count       
            this.getChildTags(response.data.data)           
            this.tagList.map(tagList => {
            this.allLists.map((list, index) => {
              if (tagList.id === list.id) {
                this.allLists.splice(index, 1)
              }
            })
          })
          if (!response.data.data.length && this.totalListCount > this.currentPage * perPage) {
            this.getAllTags()
          }
        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })
      },

      update_list (list, add) {
        let index
        if (add) {
          index = this.allLists.findIndex(x => x.id === list.id)
          this.tagList.push(
            ...this.allLists.splice(
              index < 0 ? 0 : index,
              index < 0 ? this.allLists.length : 1,
            ),
          )
        } else {
          index = this.tagList.findIndex(x => x.id === list.id)
          if (index < 0) {
            this.tagList = []
            this.currentPage = 1
          } else {
            this.allLists.unshift(...this.tagList.splice(index, 1))
          }
        }
        if (index < 0) this.getAllTags()
      },

      filterItems (presets) {
        return presets.filter(preset => {
          const regex = new RegExp('(' + this.searchString + ')', 'i')
          return preset.name.match(regex)
        })
      },
      saveSelectedTags () {
        this.loading = true
        $campaigns.setCtags({
          campaign_id: this.currentCampaignId,
          ctags: this.tagList.map(x => {
            return x.id
          })
        }).then(response => {
          this.$store.commit('ui/snackbar', { message: 'Tags was successfully updated', type: 'success' })
          this.currentPage = 1
          this.$store.commit('ui/drawer.right', {
            show: false,
            component: null,
            response: { tagList: JSON.parse(JSON.stringify(this.tagList)) },
          })
        }).finally(() => {
          this.loading = false
        })
      },

      getChildTags (item) {
        item.forEach(el => {
          this.allLists.push(el)
          if(el.children)
          this.getChildTags(el.children)
          })            
      }
      
    }
  }

  </script>